import React from "react";
import { Modal, Button, Col, Row } from "antd";
import AButton from "./Button";
import { FailedIcon } from "../../../assets/icons/Failed";
import { typography } from "theme/Typography";
import { color } from "theme/Color";

interface DeleteConfirmationModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  message?: string;
  title?: string;
  hideConfirmButton?: boolean;
  loading?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ visible, onConfirm, onCancel, message, title, hideConfirmButton, loading }) => {
  return (
    <Modal open={visible} onCancel={onCancel} width={380} closeIcon={null} footer={null} centered>
      <div className="modal-body">
        <FailedIcon />
        <p
          style={{
            fontSize: typography.fontSizes.lg,
            fontWeight: typography.fontWeights.semibold,
            lineHeight: "28px",
            color: color.TEXT_COLOR,
          }}
        >
          {title ? title : "Delete Confirmation"}
        </p>
        <p
          style={{
            fontSize: typography.fontSizes.sm,
            fontWeight: typography.fontWeights.normal,
            lineHeight: "20px",
            color: color.TEXT,
          }}
        >
          {message
            ? message
            : `Are you sure you want to delete this item? This action cannot be
          undone. Please confirm to proceed or cancel to keep the item.`}
        </p>
      </div>
      <Row gutter={14} style={{ marginTop: "30px" }}>
        {hideConfirmButton ? (
          // Only Cancel when deletion is blocked
          <Col span={24} style={{ display: "flex" }}>
            <AButton onClick={onCancel} style={{ height: "40px", fontSize: "16px", fontWeight: "600", border: `1px solid ${color.DARK}`, flex: 1 }}>
              Close
            </AButton>
          </Col>
        ) : (
          // Normal Cancel + Confirm
          <>
            <Col span={12} style={{ display: "flex" }}>
              <AButton onClick={onCancel} style={{ height: "40px", fontSize: "16px", fontWeight: "600", border: `1px solid ${color.DARK}`, flex: 1 }}>
                Cancel
              </AButton>
            </Col>
            <Col span={12} style={{ display: "flex" }}>
              <AButton type="primary" onClick={onConfirm} style={{ height: "40px", fontSize: "16px", fontWeight: "600", flex: 1 }} loading={loading}>
                Confirm
              </AButton>
            </Col>
          </>
        )}
      </Row>
    </Modal>
  );
};

export default DeleteConfirmationModal;
